import Manager from "./Manager";
import common from "../common";
import Obstacle from "./entities/Obstacle";
import SpiderObstacle from "./entities/SpiderObstacle";
import FloorSpiderObstacle from "./entities/FloorSpiderObstacle";
import BatObstacle from "./entities/BatObstacle";

export default class ObstacleManager extends Manager {

    static create(type) {
        let entity;

        switch (type) {
            case ObstacleManager.TYPE.PAINT: {
                entity = new Obstacle(new PIXI.Point(0.5, 1), P3.assets.texture("paint_bucket"), P3.assets.texture("paint_bucket_1"));
                entity.y = P3.math.randomInt(-160, -10);
                break;
            }
            case ObstacleManager.TYPE.SLIME: {
                entity = new Obstacle(new PIXI.Point(0.5, 1), P3.assets.texture("slime"), P3.assets.texture("slime_1"));
                entity.setCollider(0, -30, 60, 60);
                break;
            }
            case ObstacleManager.TYPE.SPIDER_FLOOR: {
                entity = new FloorSpiderObstacle(new PIXI.Point(0.5, 0), P3.utils.selectRandom([P3.assets.texture("spider_00"), P3.assets.texture("spider_01")]));
                // entity.setCollider(0, -30, 60, 60);
                entity.y = P3.math.randomInt(-220, -320);
                break;
            }
            case ObstacleManager.TYPE.SPIDER_STRING_A: {
                entity = new SpiderObstacle(new PIXI.Point(0.5, 0), P3.assets.texture("spider_string_00"));
                // entity.setCollider(0, -30, 60, 60);
                entity.y = -900;
                break;
            }
            case ObstacleManager.TYPE.SPIDER_STRING_B: {
                entity = new SpiderObstacle(new PIXI.Point(0.5, 0), P3.assets.texture("spider_string_01"));
                // entity.setCollider(0, -30, 60, 60);
                entity.y = -900;
                break;
            }
            case ObstacleManager.TYPE.BATS: {
                entity = new BatObstacle();
                // entity.setCollider(0, -30, 60, 60);
                entity.y = -900;
                break;
            } case ObstacleManager.TYPE.HAND: {
                entity = new Obstacle(new PIXI.Point(0.5, 1), P3.assets.texture("hand"), P3.assets.texture("crack"));
                //entity.y = P3.math.randomInt(-160, -10);
                entity.setCollider(0, -30, 60, 60);
                break;
            }
        }

        entity.type = type;

        return entity;
    }

    constructor(container) {
        super(container);

        this._types = [];

        for (let key in ObstacleManager.TYPE) {
            if (ObstacleManager.TYPE.hasOwnProperty(key)) {
                this._types.push(ObstacleManager.TYPE[key]);
            }
        }

        this._spacingMin = 290;
        this._spacingMax = 600;

        this._nextEntityX = common.STAGE_WIDTH; // start on a blank corridor with no entities

        this.worldLength = 12000;

        this._stopped = false;
    }

    populate(length) {
        if (this._stopped)
            return;

        for (let i = 0; i < length; i++) {
            const entity = ObstacleManager.create(P3.utils.selectRandom(this._types));
            entity.x = this._nextEntityX;

            this._container.addChild(entity);

            this._nextEntityX = entity.x + entity.width + P3.math.randomInt(this._spacingMin, this._spacingMax);

            if (this._nextEntityX >= this.worldLength - common.STAGE_WIDTH) {
                this._stopped = true;
                break;
            }
        }
    }

    update(player) {

        for (let i = this._container.children.length - 1; i >= 0; i--) {
            const entity = this._container.children[i];

            entity.update && entity.update(window.deltaTime);

            const global = entity.getGlobalPosition();

            if (!entity.headCollision) {
                if (!entity.activated && P3.utils.collideAABB(player.collider, entity.collider)) {
                    entity.hit();
                    player.hit(entity.type);
                    switch(entity.type){
                        case ObstacleManager.TYPE.PAINT: {
                            P3.audio.playSound("sfx_pickup_paintcan");
                            break;
                        }
                        case ObstacleManager.TYPE.SLIME: {
                            P3.audio.playSound("sfx_pickup_slime_00");
                            break;
                        }
                        case ObstacleManager.TYPE.SPIDER_FLOOR:{
                            P3.audio.playSound("sfx_pickup_web");
                            break;
                        }
                        case ObstacleManager.TYPE.SPIDER_STRING_A:
                        case ObstacleManager.TYPE.SPIDER_STRING_B : {
                            P3.audio.playSound("sfx_pickup_spider_00");
                            break;
                        }
                        case ObstacleManager.TYPE.BATS : {
                            break;
                        }
                        case ObstacleManager.TYPE.HAND : {
                            P3.audio.playSound("sfx_pickup_hand");
                            break;
                        }
                    }
                }
            } else {
                if (!entity.activated && P3.utils.collideAABB(player.headCollider, entity.collider)) {
                    entity.hit();
                    player.hit(entity.type);
                    switch(entity.type){
                        case ObstacleManager.TYPE.PAINT: {
                            P3.audio.playSound("sfx_pickup_paintcan");
                            break;
                        }
                        case ObstacleManager.TYPE.SLIME: {
                            P3.audio.playSound("sfx_pickup_slime_00");
                            break;
                        }
                        case ObstacleManager.TYPE.SPIDER_FLOOR:{
                            P3.audio.playSound("sfx_pickup_web");
                            break;
                        }
                        case ObstacleManager.TYPE.SPIDER_STRING_A:
                        case ObstacleManager.TYPE.SPIDER_STRING_B : {
                            P3.audio.playSound("sfx_pickup_spider_00");
                            break;
                        }
                        case ObstacleManager.TYPE.BATS : {
                            break;
                        }
                        case ObstacleManager.TYPE.HAND : {
                            P3.audio.playSound("sfx_pickup_hand");
                            break;
                        }
                    }
                }
            }

            if (entity.start && !entity.started && entity.x < player.x + entity.startDistance) {
                entity.start();
            }

            if (global.x <= -entity.width) {
                entity.destroy();
            }
        }

        if (!this._container.children.length || this._container.children[this._container.children.length - 1].getGlobalPosition().x <= common.STAGE_WIDTH) {
            this.populate(6);
        }

    }

}

ObstacleManager.TYPE = {};
ObstacleManager.TYPE.PAINT = "paint";
ObstacleManager.TYPE.PAINT2 = "paint"; // cheating the balance of spiders to other obstacles
ObstacleManager.TYPE.SLIME = "slime";
ObstacleManager.TYPE.SLIME2 = "slime";
ObstacleManager.TYPE.SPIDER_STRING_A = "spider_string_a";
ObstacleManager.TYPE.SPIDER_STRING_B = "spider_string_b";
ObstacleManager.TYPE.SPIDER_FLOOR = "spider_floor";
ObstacleManager.TYPE.BATS = "bats";
ObstacleManager.TYPE.HAND = "hand";